export default "__VITE_ASSET__Dvi5T4zC__"